'use strict'

export default (mockAxios) => {
  // NISFA個人連携設定を取得します。
  mockAxios.onGet(`/personal-settings/nisfa-integration`).reply(200, {
    'success': true,
    'data': {
      'enable': '1',
      'login_id': 'login',
      'login_pass': '***************',
      'auto_send': '1',
      'cretime': 20180101000000,
      'updtime': 20180101000000
    }
  })

  // NISFA個人連携設定を更新します。
  mockAxios.onPut(`/personal-settings/nisfa-integration`).reply(200, {
    'success': true,
    'data': []
  })

  // NISFA連携先へログイン（接続テスト）を行います。
  mockAxios.onPost(`/personal-settings/nisfa-integration/login`).reply(200, {
    'success': true,
    'message': ''
  })

  // NISFA連携バッチの起動を行う。
  mockAxios.onPost(`/personal-settings/nisfa-integration/execute`).reply(200, {
    'success': true
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/pvNisfaIntegrationRepositoryMock.js